/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;box-shadow:0 2px 2px 0 rgba(0,0,0,.75);border-width:1px;border-style:solid;width:100%;height:100%;padding:50% 0;overflow:auto}ul.nav-list-mobile[_ngcontent-%COMP%]{background-color:#f1f1f1;margin:auto;width:100%;padding:0}"];
export { styles as styles };
